import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  ActivityPurchaseLiteModel,
  ActivityPurchaseModel,
  getActivityPurchaseInput,
  getActivityPurchasesInput,
} from './model';

export function useGetActivityPurchases(
  input?: getActivityPurchasesInput,
  options?: UseQueryOptions<
    ExtendedApiResult<ActivityPurchaseLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<ActivityPurchaseLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getActivityPurchases', input?.params],
      () =>
        QueryFetchFunction({
          url: 'activity-purchases',
          params: input?.params,
        }),
      options,
    ),
    ActivityPurchaseLiteModel,
  );
}

export function useGetActivityPurchase(
  input?: getActivityPurchaseInput,
  options?: UseQueryOptions<ApiResult<ActivityPurchaseModel>, ApiError>,
): UseQueryResult<ApiResult<ActivityPurchaseModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getActivityPurchase', input?.id],
      () => QueryFetchFunction({ url: `activity-purchases/${input?.id}` }),
      options,
    ),
    ActivityPurchaseModel,
  );
}

export function getActivityPurchasesKey(input?: getActivityPurchasesInput) {
  return [`getActivityPurchases`, input?.params];
}

export function getActivityPurchaseKey(input?: getActivityPurchaseInput) {
  return ['getActivityPurchase', input?.id];
}
